var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLossAssetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 120L256 160L384 160L384 120C384 115.6 380.4 112 376 112L264 112C259.6 112 256 115.6 256 120zM208 160L208 120C208 89.1 233.1 64 264 64L376 64C406.9 64 432 89.1 432 120L432 160L512 160C547.3 160 576 188.7 576 224L576 480C576 515.3 547.3 544 512 544L128 544C92.7 544 64 515.3 64 480L64 224C64 188.7 92.7 160 128 160L208 160zM408 208L208 208L208 496L432 496L432 208L408 208zM480 208L480 496L512 496C520.8 496 528 488.8 528 480L528 224C528 215.2 520.8 208 512 208L480 208zM160 496L160 208L128 208C119.2 208 112 215.2 112 224L112 480C112 488.8 119.2 496 128 496L160 496zM308 272L332 272C340.8 272 348 279.2 348 288L348 324L384 324C392.8 324 400 331.2 400 340L400 364C400 372.8 392.8 380 384 380L348 380L348 416C348 424.8 340.8 432 332 432L308 432C299.2 432 292 424.8 292 416L292 380L256 380C247.2 380 240 372.8 240 364L240 340C240 331.2 247.2 324 256 324L292 324L292 288C292 279.2 299.2 272 308 272z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLossAssetIcon);
export default __webpack_public_path__ + "static/media/lossAssetIcon.ba13717531d1b1b2c963ff1699cbbb4d.svg";
export { ForwardRef as ReactComponent };